import api from './api';

export const authService = {
  login: async (username, password, totpCode = null, webauthnResponse = null) => {
    const response = await api.post('/auth/login', {
      username,
      password,
      totp_code: totpCode,
      webauthn_response: webauthnResponse,
    });
    return response.data;
  },

  requestPasswordReset: async (email) => {
    const response = await api.post('/auth/password-reset/request', { email });
    return response.data;
  },

  confirmPasswordReset: async (token, newPassword) => {
    const response = await api.post('/auth/password-reset/confirm', {
      token,
      new_password: newPassword,
    });
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await api.get('/users/me');
    return response.data;
  },
};
